import { type FC, useEffect, useState } from 'react';
import DropdownButton, { type DropdownButtonProps } from 'react-bootstrap/DropdownButton';
import './styles/styles.css';

export const DotDropDown: FC<DropdownButtonProps> = ({ className, ...rest }) => {
  const [isSmallTable, setIsSmallTable] = useState(false);

  useEffect(() => {
    const viewport = document.querySelector('.ag-center-cols-viewport');
    if (viewport) {
      const height = (viewport as HTMLElement).offsetHeight;
      setIsSmallTable(height < 250);
    }
  }, []);
  return (
    <DropdownButton
      id="dropdown-basic-button"
      className={`page-dropdown w-auto article-card-dropdown p-0 ${
        isSmallTable ? 'dropdown-scroll' : ''
      } ${className ?? ''}`}
      drop="down"
      {...rest}
    />
  );
};
